<template>
    <div class="page">
        <div class="recommend-fl">
            <div class="recommend-item">
                <div class="h5-t">
                    <div class="title">{{ payDataObj.packageName }}</div>
                    <div class="small">{{ payDataObj.remark }}</div>
                    <div class="tiem">
                        <div class="l">享权益</div>
                        <div class="r">{{ payDataObj.sheRemark }}</div>
                    </div>
                </div>
                <div class="btn-or-h">
                    <div class="youhui">
                        <div class="price">￥<span>{{ payDataObj.salePriceRmb }}</span>元</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box" v-if="payDataObj.isShowAddPkg === 1">套餐增值服务</div>

        <div class="activity" v-if="payDataObj.isShowAddPkg === 1">
            <div class="tl">
                <div class="l-tl">限时专属套餐活动</div>
                <div class="r-tl">+{{ payDataObj.sheXuPrice }}元</div>
            </div>
            <div class="bl">
                <div class="l-bl">+{{ payDataObj.sheXuPrice }}元可格外获得{{ payDataObj.sheXuDay }}天套餐时间</div>
                <div class="r-bl">
                    <van-checkbox v-model="radio" checked-color="#C47A3A"></van-checkbox>
                </div>
            </div>
        </div>

        <div class="roll">
            <div class="l-r">
                <img src="@/assets/new/40.png" alt="">
                优惠券
            </div>
            <div class="r-r">-¥{{ payDataObj.juanPrice }}</div>
        </div>

        <div class="box">选择支付方式</div>

        <div class="payType">
            <van-radio-group v-model="payRadio">
                <van-cell-group>
                    <van-cell v-if="showPayChannel('wxCollectConfig')" title="微信支付" clickable class="wx-icon">
                        <template #right-icon>
                            <van-radio name="wxCollectConfig" checked-color="#C47A3A" />
                        </template>
                    </van-cell>
                    <van-cell v-if="showPayChannel('yyCollectConfig')" title="微信支付" clickable class="wx-icon">
                        <template #right-icon>
                            <van-radio name="yyCollectConfig" checked-color="#C47A3A" />
                        </template>
                    </van-cell>
                    <van-cell v-if="showPayChannel('lsCollectConfig')" title="微信支付" clickable class="wx-icon">
                        <template #right-icon>
                            <van-radio name="lsCollectConfig" checked-color="#C47A3A" />
                        </template>
                    </van-cell>
                    <van-cell title="支付宝" clickable class="ali-icon">
                        <template #right-icon>
                            <van-radio name="aliCollectConfig" checked-color="#C47A3A" />
                        </template>
                    </van-cell>
                    <van-cell v-if="showPayChannel('yeCollectConfig')" title="余额支付" clickable class="yue-icon">
                        <template #right-icon>
                            <van-radio name="yeCollectConfig" checked-color="#C47A3A" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>

        <!-- <div class="h-vip">
            <div class="v-all">
                <div class="h-tl">极速会员</div>
                <div class="h-ts">
                    <div class="l-ts"> + 网速提高300%</div>
                    <div class="l-ts"> + 独享上网频段</div>
                </div>
                <div class="h-ts">
                    <div class="l-ts"> + 信号加强300%</div>
                    <div class="l-ts"> + VIP专属客服</div>
                </div>
                <div class="f-btn">开通会员即享权益</div>
            </div>
        </div> -->


        <div class="h-vip">
            <div class="v-all">
                <div class="h-tl">随心换</div>
                <div class="h-ts">
                    <div class="l-ts">设备损坏丢失</div>
                    <div class="l-ts">免费换新 </div>
                </div>
                <div class="h-ts">
                    <div class="l-ts">设备到期</div>
                    <div class="l-ts">可以估值回收</div>
                </div>
                <div class="f-btn">开通会员即享权益</div>
            </div>
        </div>


        <div class="footer">
            <div class="f-tl">
                <div class="l-f">
                    开通权益会员预计可省<span>150元/年</span>，四大权益特惠尝鲜<span>¥{{ payDataObj.sheVipPrice }}元</span>{{
                        payDataObj.sheVipRemark }}
                </div>
                <div class="r-f">
                    <van-checkbox v-model="radio1" checked-color="#C47A3A" @click="changRadio"></van-checkbox>
                </div>
            </div>
            <div class="take">
                <van-radio-group v-model="isNextMonth" direction="horizontal" checked-color="#C47A3A">
                    <van-radio name="0">立即生效</van-radio>
                    <van-radio name="1">次月生效</van-radio>
                </van-radio-group>
            </div>
            <div class="f-f">
                <div class="customer" @click="link">
                    <img src="@/assets/new/44.png" alt="">
                    <div>专属客服</div>
                </div>
                <div class="r-btn">
                    <div class="total-price">
                        总计：
                        <span style="font-size:14px;">￥</span>
                        <span v-if="!radio1 && radio">{{ (payDataObj.salePriceRmb + payDataObj.sheXuPrice -
                            payDataObj.juanPrice) > 0 ? payDataObj.salePriceRmb + payDataObj.sheXuPrice -
                        payDataObj.juanPrice : 0 }}元</span>
                        <span v-if="!radio && radio1">{{ (payDataObj.salePriceRmb + payDataObj.sheVipPrice -
                            payDataObj.juanPrice) > 0 ? payDataObj.salePriceRmb + payDataObj.sheVipPrice -
                        payDataObj.juanPrice : 0 }}元</span>
                        <span v-if="!radio && !radio1">{{ (payDataObj.salePriceRmb - payDataObj.juanPrice) > 0 ?
                            payDataObj.salePriceRmb - payDataObj.juanPrice : 0 }}元</span>
                        <span v-if="radio1 && radio">{{ (payDataObj.salePriceRmb + payDataObj.sheVipPrice +
                            payDataObj.sheXuPrice - payDataObj.juanPrice) > 0 ? payDataObj.salePriceRmb +
                            payDataObj.sheVipPrice + payDataObj.sheXuPrice - payDataObj.juanPrice : 0 }}元</span>
                    </div>
                    <div class="sum-btn" @click="sumbit">确认支付</div>
                </div>
            </div>
        </div>



        <!-- 密码框 -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center passwordPanel"
            style="z-index: 2000; min-height: 35%; min-width: 80%;" v-show="showPasswordPanel"
            :style="{ top: PasswordPanelTop + '%' }">

            <div class="cancelInput">
                <van-icon name="cross" @click="cancelInputPassword()" />
            </div>
            <p style="color:red">初始密码默认6个0</p>
            <h1>
                <span>￥</span>
                <span v-if="!radio1 && radio">{{ (payDataObj.salePriceRmb + payDataObj.sheXuPrice -
                    payDataObj.juanPrice) >
                    0
                    ? payDataObj.salePriceRmb + payDataObj.sheXuPrice - payDataObj.juanPrice : 0 }}</span>
                <span v-if="!radio && radio1">{{ (payDataObj.salePriceRmb + payDataObj.sheVipPrice -
                    payDataObj.juanPrice) >
                    0 ? payDataObj.salePriceRmb + payDataObj.sheVipPrice - payDataObj.juanPrice : 0 }}</span>
                <span v-if="!radio && !radio1">{{ (payDataObj.salePriceRmb - payDataObj.juanPrice) > 0 ?
                    payDataObj.salePriceRmb - payDataObj.juanPrice : 0 }}</span>
                <span v-if="radio1 && radio">{{ (payDataObj.salePriceRmb + payDataObj.sheVipPrice +
                    payDataObj.sheXuPrice -
                    payDataObj.juanPrice) > 0 ? payDataObj.salePriceRmb + payDataObj.sheVipPrice + payDataObj.sheXuPrice
                -
                    payDataObj.juanPrice : 0 }}</span>
            </h1>
            <!-- 密码输入框 -->
            <van-password-input :value="yuePayParam.payPass" :focused="showKeyboard" @focus="onfocus()" />
        </div>
        <van-overlay :show="overlay" z-index='2020'>
            <div class="wrapper">
                <van-loading type="spinner" color="#fff" />
            </div>
        </van-overlay>
        <!-- 密码框  end -->
        <!-- 数字键盘 -->
        <van-number-keyboard id="keyboardDefined" :z-index="2015" :show="showKeyboard" @input="onInput"
            @delete="onDelete" @blur="showKeyboard = false" />


    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            payTypeList: [],
            payDataObj: {},
            payRadio: '',
            radio: false,
            radio1: true,
            yuePayParam: {
                orderNo: '',
                payPass: '',
                iccid: localStorage.getItem("iccid"),
                mobile: localStorage.getItem("mobile"),
            },
            num: 0,
            isNextMonth: '0',
            //密码输入
            showPasswordPanel: false,
            showKeyboard: false,
            overlay: false,
            PasswordPanelTop: 50,
            showKeyboardZIndex: 2015,
        }
    },
    created() {
        this.payDataObj = JSON.parse(decodeURIComponent(this.$route.query.p)) || {};
        let data = { iccid: localStorage.getItem('iccid') }
        this.radio = this.payDataObj.isShowAddPkg === 1
        wxRequest('/order/pay/chanle', data, 'post').then(res => {
            console.log(1, this.typeStyle)
            if (res.data.code == 200) {
                for (let i = 0; i < res.data.data.length; i++) {
                    this.payTypeList.push(res.data.data[i].typeKey);
                }
            } else if (res.data.code == 205) {
                if (this.typeStyle == 1) {
                    this.payTypeList.push('yeCollectConfig')
                } else {
                    for (let i = 0; i < res.data.data.length; i++) {
                        this.payTypeList.push(res.data.data[i].typeKey);
                    }
                }
            }
        })
    },
    methods: {
        showPayChannel(payType) {
            return this.payTypeList.includes(payType);
        },

        link() {
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest('/she//to/kefu', data, 'post').then(res => {
                if (res.data.code == 200) {
                    window.open(this.payDataObj.sheVipKefu)
                } else {
                    Toast('开通极速会员后，即可享受快捷专属客服服务')
                }
            })
        },
        onfocus() {
            this.showKeyboard = true;
            this.PasswordPanelTop = 30;
        },

        onDelete() {
            this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, this.yuePayParam.payPass.length - 1);
        },
        cancelInputPassword() {
            this.yuePayParam.payPass = '';
            this.showPasswordPanel = false;
        },
        changRadio(status) {
            if (this.num < 3) {
                this.num++
                this.radio1 = true
            }
        },
        sumbit() {
            if (!this.payRadio) {
                Toast('请选择支付方式')
                return
            }
            if (!this.isNextMonth) {
                Toast('请选择生效方式')
                return
            }
            let formData = new FormData();
            formData.append('iccid', this.payDataObj.iccid);
            formData.append('soldPackageId', this.payDataObj.soldPackageId);
            formData.append('isNextMonth', this.isNextMonth);
            formData.append('isAdmin', this.payDataObj.isAdmin);
            formData.append('juanPrice', this.payDataObj.juanPrice);
            formData.append('source', 1);
            if (this.radio) {
                formData.append('addPrice', this.payDataObj.sheXuPrice || 0);
            } else {
                formData.append('addPrice', 0);
            }
            if (this.radio1) {
                formData.append('vipPrice', this.payDataObj.sheVipPrice || 0);
            } else {
                formData.append('vipPrice', 0);
            }
            var jsonData = {};
            formData.forEach((value, key) => jsonData[key] = value)
            //微信支付
            if (this.payRadio === 'wxCollectConfig') {
                wxRequest("order/pkgOrder/add", formData, "post").then(res => {
                    if (res.data.code == 200) {
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                            }
                        } else {
                            let param = res.data.data.param;
                            this.onBridgeReady(param);
                        }
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                })
            } else if (this.payRadio === 'yyCollectConfig') {
                formData.append("buyCode", "201")
                wxRequest("order/pkgOrder/add", formData, "post").then(res => {
                    if (res.data.code == 200) {
                        window.location.href = res.data.data;
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                })
            } else if (this.payRadio === 'lsCollectConfig') {
                wxRequest("order/lsPkgOrder/add", formData, "post").then(res => {
                    if (res.data.code == 200) {
                        window.location.href = res.data.data.jspay_url;
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                })
            } else if (this.payRadio === 'aliCollectConfig') {  //支付宝
                formData.append("buyCode", "261")
                wxRequest("order/pkgOrder/add", formData, "post").then(res => {
                    if (res.data.code == 200) {
                        window.location.href = res.data.data;
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                })
            } else { //余额
                wxRequest("order/user/uniorder", jsonData, "post").then(res => {
                    if (res.data.code === '200') {
                        this.yuePayParam.orderNo = res.data.data.id;
                        this.yuePayParam.iccid = localStorage.getItem("iccid");
                        this.yuePayParam.mobile = localStorage.getItem("mobile");
                        //唤起密码输入框
                        this.showPasswordPanel = true;
                    } else if (res.data.code == 402) {
                        let self = this;
                        Dialog.confirm({
                            title: '提示',
                            message: '账户余额不足, 请点击【确认】前往充值余额后再来购买套餐！'
                        }).then(() => {
                            // on confirm
                            self.$router.push({
                                path: '/new/balanceRecharge',
                                query: {
                                    iccid: self.$store.state.iccid
                                }
                            });
                        }).catch(() => {

                        });
                    } else {
                        this.$messagebox.alert(res.data.message);
                    }
                })
            }
        },
        //流量套餐充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                        _this.$router.push({
                            path: "/userNew/home",
                            query: {
                                iccid: _this.$store.state.iccid,
                            },
                        })
                            .catch(() => { });
                    } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
                        _this.$router
                            .push({
                                path: "/user/homeNew",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    } else if (_this.$store.state.isNewPage == 3 || localStorage.getItem('isNewPage') == 3) {
                        _this.$router
                            .push({
                                path: "/new/home",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    } else {
                        _this.$router
                            .push({
                                path: "/user/home",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    }
                }
            });
        },
        onInput(key) {
            this.yuePayParam.payPass = (this.yuePayParam.payPass + key).slice(0, 6);
            if (this.yuePayParam.payPass.length >= 6) {
                this.PasswordPanelTop = 50;
                this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, 6);
                this.overlay = true;
                wxRequest("order/sysUser/wx/ye/pkg", this.yuePayParam, "post").then(res => {
                    if (res.data.code == 200) {
                        Toast.success(res.data.message);
                        this.yuePayParam.payPass = '';
                        this.overlay = false;
                        let s = this;
                        setTimeout(function () {
                            if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                                _this.$router
                                    .push({
                                        path: "/userNew/home",
                                        query: {
                                            iccid: _this.$store.state.iccid,
                                        },
                                    })
                                    .catch(() => { });
                            } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
                                _this.$router
                                    .push({
                                        path: "/user/homeNew",
                                        query: {
                                            iccid: _this.$store.state.iccid,
                                        },
                                    })
                                    .catch(() => { });
                            } else if (_this.$store.state.isNewPage == 3 || localStorage.getItem('isNewPage') == 3) {
                                _this.$router
                                    .push({
                                        path: "/new/home",
                                        query: {
                                            iccid: _this.$store.state.iccid,
                                        },
                                    })
                                    .catch(() => { });
                            } else {
                                _this.$router
                                    .push({
                                        path: "/user/home",
                                        query: {
                                            iccid: _this.$store.state.iccid,
                                        },
                                    })
                                    .catch(() => { });
                            }
                        }, 1000);
                    } else if (res.data.code == 402) {
                        this.overlay = false;
                        this.yuePayParam.payPass = '';
                        let self = this;
                        Dialog.confirm({
                            title: '提示',
                            message: '账户余额不足, 请点击【确认】前往充值余额后再来购买套餐！'
                        }).then(() => {
                            // on confirm
                            self.$router.push({
                                path: '/new/balanceRecharge',
                                query: {
                                    iccid: self.$store.state.iccid
                                }
                            });
                        }).catch(() => {

                        });
                    } else {
                        this.overlay = false;
                        Dialog.alert({ title: '提示', message: res.data.message }).then(action => {
                            this.yuePayParam.payPass = '';
                        }).catch(() => { });

                    }
                });
            }
        },
    }

}
</script>
<style lang="less" scoped>
.page {
    width: 100%;
    background: #FFEFE1;
    /* padding-top: 17px; */
    padding-bottom: 160px;
    position: relative;

    .recommend-fl {
        margin: 0 14px;

        .recommend-item {
            box-shadow: 0px 0px 8px 0px #EFD0B5;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 10px 10px 13px;

            .h5-t {
                border-radius: 10px;
                background: url('~@/assets/new/26.png') no-repeat;
                background-size: 100% 100%;
                padding: 17px 13px 11px 16px;

                .title {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #1D1B19;
                    line-height: 22px;
                    padding-bottom: 8px;
                }

                .small {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #908B85;
                    line-height: 20px;
                }

                .tiem {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 18px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFEFE1;
                    line-height: 20px;

                    .l {
                        background: #FF7C00;
                        border-radius: 4px;
                        padding: 6px 10px;
                    }

                    .r {
                        color: #FF7C00;
                        margin-left: 8px;
                    }
                }
            }

            .btn-or-h {
                margin-top: 14px;
                height: 50px;
                border-radius: 26px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #FFEFE1;

                .youhui {
                    .price {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #1D1B19;
                        line-height: 20px;

                        span {
                            font-size: 22px;
                            font-family: HarmonyOS_Sans_SC_Bold;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }

    .box {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #1D1B19;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-top: 22px;
        margin-left: 14px;
        display: flex;
        align-items: center;
    }

    .activity {
        margin-top: 12px;
        height: 53px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px #EFD0B5;
        margin-left: 14px;
        margin-right: 14px;
        border-radius: 8px;
        padding: 14px 16px 17px 13px;

        .tl {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .l-tl {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 18px;
                color: #28292D;
                line-height: 25px;
            }

            .r-tl {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 20px;
                font-weight: 600;
                color: #C47A3A;
                line-height: 29px;
            }
        }

        .bl {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4px;

            .l-tl {
                font-family: PingFangSC, PingFang SC;
                font-size: 12px;
                color: #63666D;
                font-weight: bold;
                line-height: 17px;
            }

            .r-tl {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 20px;
                font-weight: 600;
                color: #C47A3A;
                line-height: 29px;
            }
        }
    }

    .roll {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px #EFD0B5;
        margin-left: 14px;
        margin-right: 14px;
        border-radius: 8px;
        margin-top: 14px;
        padding: 10px 13px;

        .l-r {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #28292D;
            font-weight: bold;
            line-height: 25px;
        }

        img {
            width: 24px;
            height: 19px;
            vertical-align: sub;
            margin-right: 8px;
        }

        .r-r {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #FF342C;
            line-height: 22px;
        }
    }

    .payType {
        margin-left: 14px;
        margin-right: 14px;
        margin-top: 12px;
        padding: 20px 14px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px #EFD0B5;
        border-radius: 8px;

        .van-cell::after {
            border: none;
        }

        ::v-deep .van-cell-group::after {
            border: none;
        }

        .wx-icon {
            background: url('~@/assets/new/43.png') left center no-repeat;
            background-size: 26px 21px;
            padding-left: 35px;
            color: #28292D;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
        }

        .ali-icon {
            background: url('~@/assets/new/41.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
            color: #28292D;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
        }

        .yue-icon {
            background: url('~@/assets/new/42.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            color: #28292D;
        }
    }

    .h-vip {
        margin-left: 14px;
        margin-right: 14px;
        margin-top: 12px;
        height: 173px;
        background: url('~@/assets/new/39.png')no-repeat center;
        background-size: 100% 100%;

        .v-all {
            width: 56%;
            padding-left: 20px;
            padding-top: 20px;
            padding-bottom: 28px;

            .h-tl {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 34px;
                line-height: 48px;
                background: linear-gradient(180deg, #F1DFC6 0%, #D9A098 100%);
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: bold;
            }

            .h-ts {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .l-ts {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #E7C5B3;
                    line-height: 22px;
                }
            }

            .f-btn {
                background: linear-gradient(270deg, #333C6D 0%, #232A50 100%);
                border-radius: 6px;
                border: 1px solid #E7C5B3;
                height: 30px;
                width: 120px;
                font-size: 12px;
                color: #E7C5B3;
                font-family: PingFangSC, PingFang SC;
                text-align: center;
                line-height: 30px;
                margin-top: 10px;
            }
        }
    }

    .footer {
        position: fixed;
        width: 100%;
        height: 156px;
        bottom: 0;
        background: #FFEFE1;

        .f-tl {
            margin: 0 14px;
            padding-top: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .l-f {
                width: 80%;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #28292D;
                line-height: 17px;

                span {
                    color: #C47A3A;
                }
            }
        }

        .take {
            height: 44px;
            background: rgba(196, 122, 58, .2);
            padding-left: 14px;
            margin-top: 7px;

            .van-radio-group {
                height: 100%;

                ::v-deep .van-radio__label {
                    color: #C47A3A;
                    font-size: 14px;
                    font-family: PingFangSC, PingFang SC;
                }

                ::v-deep .van-icon {
                    background: #fff;
                }
            }
        }

        .f-f {
            height: 62px;
            display: flex;
            align-items: center;

            .customer {
                width: 72px;
                text-align: center;
                background: #F9F9F9;
                height: 100%;

                img {
                    width: 22px;
                    height: 22px;
                    margin-top: 9px;
                    margin-bottom: 4px;
                }

                div {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #CC8C6A;
                    line-height: 17px;
                }
            }

            .r-btn {
                width: calc(100% - 72px);
                background: #FFFFFF;
                height: 100%;
                display: flex;
                align-items: center;
            }

            .total-price {
                margin-left: 46px;
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                line-height: 20px;
                color: #1D1B19;

                span {
                    font-family: HarmonyOS_Sans_SC_Bold;
                    color: #C47A3A;
                    font-size: 24px;
                    font-weight: bold;
                }
            }

            .sum-btn {
                margin-left: 10px;
                border-radius: 22px;
                width: 120px;
                height: 44px;
                text-align: center;
                line-height: 40px;
                font-size: 18px;
                color: #FFFFFF;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                background: #C47A3A;
            }
        }
    }

    .passwordPanel {
        p {
            text-align: center;
            color: '#323233';
            margin-bottom: 30px;
        }

        h1 {
            font-size: 28px;
            text-align: center;
            color: '#323233';
            margin-bottom: 30px;

            span {
                font-size: 20px;
            }

        }

        .van-cell-group {
            padding: 10px 5px;
        }

    }

    .cancelInput {
        height: 20px;
    }

    .cancelPay {
        padding: 0 30px 50px 30px;

        >div {
            float: right;
        }
    }
}
</style>
<style scoped>
.page .cancelInput .van-icon {
    margin: 10px 15px 10px 0;
    position: absolute;
    right: 0;
}
</style>